import React, { useRef } from "react";

import Konva from "konva";
import { Group, Rect } from "react-konva";
import { useTheme } from "@mui/material";

interface VerticalLineProps {
  x: number;
  onDrag: (x: number) => void;
  height?: number;
}

const HANDLE_WIDTH = 12;
const HANDLE_HEIGHT = 16;

export default function VerticalLine({
  x,
  onDrag,
  height = 200,
}: VerticalLineProps) {
  const theme = useTheme();
  const groupRef = useRef<Konva.Group>(null);
  const manualUpdateRef = useRef(false);
  const color = theme.palette.primary.main;

  const handleDragMove = (e: any) => {
    manualUpdateRef.current = true;
    e.target.y(0); // Prevent vertical movement
    onDrag(e.target.x());
  };

  const handleMouseEnter = (e: any) => {
    const stage = e.target.getStage();
    stage.container().style.cursor = "grab";
  };

  const handleMouseLeave = (e: any) => {
    e.target.getStage().container().style.cursor = "default";
  };

  const handleDragStart = (e: any) => {
    e.target.getStage().container().style.cursor = "grabbing";
  };

  const handleDragEnd = (e: any) => {
    e.target.getStage().container().style.cursor = "grab";
    manualUpdateRef.current = false;
  };

  React.useEffect(() => {
    if (groupRef.current && !manualUpdateRef.current) {
      groupRef.current.to({
        duration: 0.3,
        x,
      });
    }
  }, [x]);

  return (
    <Group
      ref={groupRef}
      y={0}
      draggable
      onDragMove={handleDragMove}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
    >
      {/* Wide transparent hit area so the 2px line is easy to grab */}
      <Rect x={-6} y={0} width={12} height={height} fill="transparent" />
      <Rect
        x={-1}
        y={HANDLE_HEIGHT - 2}
        width={2}
        height={height - HANDLE_HEIGHT}
        fill={color}
        listening={false}
      />
      <Rect
        x={-HANDLE_WIDTH / 2}
        y={2}
        width={HANDLE_WIDTH}
        height={HANDLE_HEIGHT}
        cornerRadius={[4, 4, 6, 6]}
        fill={color}
        shadowColor="black"
        shadowOpacity={0.3}
        shadowBlur={4}
        shadowOffsetY={1}
        listening={false}
      />
    </Group>
  );
}
